/* eslint-disable react-hooks/exhaustive-deps */
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import {
  TNinusiRegisterPostReqSchema,
  TNinusiUpdatePutReqSchema,
} from "../../../service/master/ninusi/ninusiSchema"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import {
  TNinusiRegisterPostReq,
  TNinusiUpdatePutReq,
} from "../../../service/master/ninusi/TNinusi"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"

const MasterNinusiRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.荷主マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [荷主コード, set荷主コード] = useState<string>("")
  const [荷主名, set荷主名] = useState<string>("")
  const [荷主名カナ, set荷主名カナ] = useState<string>("")
  const [荷主略称1, set荷主略称１] = useState<string>("")
  const [荷主略称2, set荷主略称２] = useState<string>("")
  const [郵便番号, set郵便番号] = useState<string>("")
  const [住所１, set住所１] = useState<string>("")
  const [住所２, set住所２] = useState<string>("")
  const [住所３, set住所３] = useState<string>("")
  const [電話番号, set電話番号] = useState<string>("")
  const [FAX番号, setFAX番号] = useState<string>("")
  const [荷主担当者, set荷主担当者] = useState<string>("")
  const [集計荷主コード, set集計荷主コード] = useState<string>("")
  const [インボイス登録番号, setインボイス登録番号] = useState<string>("")
  const [更新日時, set更新日時] = useState<string>("")
  const [最終更新ID, set最終更新ID] = useState<string>()

  // エラー表示用フラグ
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid荷主名, setIsInvalid荷主名] = useState<boolean>(false)
  const [isInvalid荷主名カナ, setIsInvalid荷主名カナ] = useState<boolean>(false)
  const [isInvalid荷主略称1, setIsInvalid荷主略称１] = useState<boolean>(false)
  const [isInvalid荷主略称2, setIsInvalid荷主略称２] = useState<boolean>(false)
  const [isInvalid郵便番号, setIsInvalid郵便番号] = useState<boolean>(false)
  const [isInvalid住所１, setIsInvalid住所１] = useState<boolean>(false)
  const [isInvalid住所２, setIsInvalid住所２] = useState<boolean>(false)
  const [isInvalid住所３, setIsInvalid住所３] = useState<boolean>(false)
  const [isInvalid電話番号, setIsInvalid電話番号] = useState<boolean>(false)
  const [isInvalidFAX番号, setIsInvalidFAX番号] = useState<boolean>(false)
  const [isInvalid荷主担当者, setIsInvalid荷主担当者] = useState<boolean>(false)
  const [isInvalid集計荷主コード, setIsInvalid集計荷主コード] =
    useState<boolean>(false)
  const [, setIsInvalid更新日時] = useState<boolean>(false)
  const [isInvalidインボイス登録番号, setIsInvalidインボイス登録番号] =
    useState<boolean>(false)

  //#region [comboboxState]
  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new NinusiService()

    try {
      const res = await service.get(id)
      if (res.data) {
        // TODO:詰め方をチェック
        set荷主コード(res.data.荷主コード)
        set荷主名(res.data.荷主名)
        set荷主名カナ(res.data.荷主名カナ)
        set荷主略称１(res.data.荷主略称1)
        set荷主略称２(res.data.荷主略称2)
        set郵便番号(res.data.郵便番号)
        set住所１(res.data.住所１)
        set住所２(res.data.住所２)
        set住所３(res.data.住所３)
        set電話番号(res.data.電話番号)
        setFAX番号(res.data.FAX番号)
        set荷主担当者(res.data.荷主担当者)
        set集計荷主コード(res.data.集計荷主コード)
        setインボイス登録番号(res.data.インボイス登録番号)
        set更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 登録アイテム生成
   */
  const getPostReq = (): TNinusiRegisterPostReq => {
    return {
      荷主コード,
      荷主名,
      荷主名カナ,
      荷主略称1,
      荷主略称2,
      郵便番号,
      住所１,
      住所２,
      住所３,
      電話番号,
      FAX番号,
      荷主担当者,
      集計荷主コード,
      インボイス登録番号,
    }
  }

  /**
   * 更新アイテム生成
   */
  const getPutReq = (): TNinusiUpdatePutReq => {
    return {
      荷主コード,
      荷主名,
      荷主名カナ,
      荷主略称1,
      荷主略称2,
      郵便番号,
      住所１,
      住所２,
      住所３,
      電話番号,
      FAX番号,
      荷主担当者,
      集計荷主コード,
      インボイス登録番号,
      更新日時,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = TNinusiUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = TNinusiRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid荷主コード(errorProperties.includes("荷主コード"))
    setIsInvalid荷主名(errorProperties.includes("荷主名"))
    setIsInvalid荷主名カナ(errorProperties.includes("荷主名カナ"))
    setIsInvalid荷主略称１(errorProperties.includes("荷主略称1"))
    setIsInvalid荷主略称２(errorProperties.includes("荷主略称2"))
    setIsInvalid郵便番号(errorProperties.includes("郵便番号"))
    setIsInvalid住所１(errorProperties.includes("住所１"))
    setIsInvalid住所２(errorProperties.includes("住所２"))
    setIsInvalid住所３(errorProperties.includes("住所３"))
    setIsInvalid電話番号(errorProperties.includes("電話番号"))
    setIsInvalidFAX番号(errorProperties.includes("FAX番号"))
    setIsInvalid荷主担当者(errorProperties.includes("荷主担当者"))
    setIsInvalid集計荷主コード(errorProperties.includes("集計荷主コード"))
    setIsInvalidインボイス登録番号(
      errorProperties.includes("インボイス登録番号")
    )
    setIsInvalid更新日時(errorProperties.includes("更新日時"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (
        荷主コード == null ||
        荷主名 == null //||
      )
        return

      const service = new NinusiService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`荷主マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()
    // id存在時はデータを取得し更新
    if (id) {
      getData(id, abortController.signal).finally(() => {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = true
      })
    } else {
      disPatch(画面ロック解除())
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>

      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">荷主マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-75rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 荷主 */}
                  <MasterRegisterFormRow
                    label="荷主コード"
                    isRequired={true}
                    remarks={<div>半角英数字5桁まで</div>}>
                    <TextInput
                      style={{ width: "7rem" }}
                      id="荷主コード"
                      name="荷主コード"
                      isReadOnly={id != null}
                      isRequired={true}
                      value={荷主コード}
                      setValue={(v) => {
                        set荷主コード(v)
                      }}
                      maxLength={5}
                      className={isInvalid荷主コード ? "is-error" : ""}
                      autoFocus={true}
                    />
                  </MasterRegisterFormRow>
                  {/* 荷主名 */}
                  <MasterRegisterFormRow label="荷主名" isRequired={true}>
                    <TextInput
                      style={{ width: "30rem" }}
                      id="荷主名"
                      name="荷主名"
                      isRequired={true}
                      value={荷主名}
                      setValue={set荷主名}
                      maxLength={40}
                      className={isInvalid荷主名 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 荷主名カナ */}
                  <MasterRegisterFormRow label="荷主名カナ">
                    <TextInput
                      style={{ width: "30rem" }}
                      id="荷主名カナ"
                      name="荷主名カナ"
                      value={荷主名カナ}
                      setValue={set荷主名カナ}
                      maxLength={100}
                      className={isInvalid荷主名カナ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 荷主略称１ */}
                  <MasterRegisterFormRow isRequired={true} label="荷主略称１">
                    <TextInput
                      style={{ width: "20rem" }}
                      id="荷主略称１"
                      name="荷主略称１"
                      isRequired={true}
                      value={荷主略称1}
                      setValue={set荷主略称１}
                      maxLength={100}
                      className={isInvalid荷主略称1 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 荷主略称２ */}
                  <MasterRegisterFormRow label="荷主略称２">
                    <TextInput
                      id="荷主略称２"
                      name="荷主略称２"
                      value={荷主略称2}
                      setValue={set荷主略称２}
                      maxLength={100}
                      className={isInvalid荷主略称2 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 郵便番号 */}
                  <MasterRegisterFormRow
                    label="郵便番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="郵便番号"
                      name="郵便番号"
                      value={郵便番号}
                      setValue={set郵便番号}
                      maxLength={100}
                      placeholder="郵便番号"
                      className={isInvalid郵便番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所１ */}
                  <MasterRegisterFormRow label="住所１" isRequired={false}>
                    <TextInput
                      id="住所１"
                      name="住所１"
                      value={住所１}
                      setValue={set住所１}
                      maxLength={100}
                      placeholder="都道府県"
                      className={isInvalid住所１ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所２ */}
                  <MasterRegisterFormRow label="住所２" isRequired={false}>
                    <TextInput
                      id="住所２"
                      name="住所２"
                      value={住所２}
                      setValue={set住所２}
                      maxLength={100}
                      placeholder="市区町村"
                      className={isInvalid住所２ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所３ */}
                  <MasterRegisterFormRow label="住所３" isRequired={false}>
                    <TextInput
                      style={{ width: "30rem" }}
                      id="住所３"
                      name="住所３"
                      value={住所３}
                      setValue={set住所３}
                      maxLength={100}
                      placeholder="町名番地"
                      className={isInvalid住所３ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 電話番号 */}
                  <MasterRegisterFormRow
                    label="電話番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="電話番号"
                      name="電話番号"
                      value={電話番号}
                      setValue={set電話番号}
                      maxLength={15}
                      className={isInvalid電話番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* FAX番号 */}
                  <MasterRegisterFormRow
                    label="FAX番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="FAX番号"
                      name="FAX番号"
                      value={FAX番号}
                      setValue={setFAX番号}
                      maxLength={15}
                      className={isInvalidFAX番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 荷主担当者 */}
                  <MasterRegisterFormRow label="荷主担当者" isRequired={false}>
                    <TextInput
                      id="荷主担当者"
                      name="荷主担当者"
                      value={荷主担当者}
                      setValue={set荷主担当者}
                      maxLength={100}
                      className={isInvalid荷主担当者 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 集計荷主コード */}
                  <MasterRegisterFormRow label="集計荷主コード">
                    <TextInput
                      style={{ width: "7rem" }}
                      id="集計荷主コード"
                      name="集計荷主コード"
                      value={集計荷主コード}
                      setValue={set集計荷主コード}
                      maxLength={5}
                      className={isInvalid集計荷主コード ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* インボイス登録番号 */}
                  <MasterRegisterFormRow
                    label="インボイス登録番号"
                    remarks={<div>適格請求書発行事業者の登録番号</div>}>
                    <TextInput
                      id="インボイス登録番号"
                      name="インボイス登録番号"
                      value={インボイス登録番号}
                      setValue={setインボイス登録番号}
                      maxLength={20}
                      className={isInvalidインボイス登録番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          {!読取専用フラグ && (
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            </Col>
          )}
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}
export default MasterNinusiRegister

//#region  ダミーデータ

// TODO:ダミーデータ

//#endregion
